var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEditBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 94"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7223 2.28923L13.3813 3.63024L11.3698 1.61873L12.7108 0.277731C13.0811 -0.0925767 13.6815 -0.092577 14.0518 0.277731L14.7223 0.948232C15.0926 1.31854 15.0926 1.91893 14.7223 2.28923Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8.9885L10.6993 2.28923L12.7108 4.30074L6.0115 11H4V8.9885Z",
    fill: "#2F80ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2H9.89131L8.89131 3H2V13H12V6.10869L13 5.10869V13C13 13.5523 12.5523 14 12 14H2C1.44772 14 1 13.5523 1 13V3C1 2.44772 1.44772 2 2 2Z",
    fill: "#2F80ED"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditBlue);
export default __webpack_public_path__ + "static/media/edit_blue.6cdf360a.svg";
export { ForwardRef as ReactComponent };